import React from 'react';
import { Link } from 'react-router-dom';
import classes from './EmptyList.module.scss';

export default function EmptyList({ mainTitle = '', secondaryTitle = '', buttonTitle = '', routeForNavigation = '' }) {
  return (
    <div className={classes.container}>
      <span className={classes.mainTitle}>{mainTitle}</span>
      <span className={classes.secondaryTitle}>{secondaryTitle}</span>
      {routeForNavigation && buttonTitle && <Link to={routeForNavigation}>{buttonTitle}</Link>}
    </div>
  );
}
